import list from 'modules/order/list/orderListReducers';
import packing from 'modules/order/packing/orderPackingReducers';
import form from 'modules/order/form/orderFormReducers';
import view from 'modules/order/view/orderViewReducers';
import destroy from 'modules/order/destroy/orderDestroyReducers';
import generateTag from 'modules/order/generateTag/orderGenerateTagReducers';
import importerReducer from 'modules/order/importer/orderImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  generateTag,
  importer: importerReducer,
  packing
});
